import { DEFAULT_LANGUAGE } from 'src/configs/AppConfig';
import moment from 'moment';

moment.locale(DEFAULT_LANGUAGE);

export default moment;
